import { BASE_GALLERY_URL, BASE_GALLERY_ID_URL } from '@/constants/API'

export const LOAD_GALLERY = 'LOAD_GALLERY'
export const LOAD_GALLERY_ASYNC = 'LOAD_GALLERY_ASYNC'
export const LOAD_GALLERY_ITEM = 'LOAD_GALLERY_ITEM'
export const LOAD_GALLERY_ITEM_ASYNC = 'LOAD_GALLERY_ITEM_ASYNC'
export const CLEAR_GALLERY = 'CLEAR_GALLERY'

const gallery = {
  state: {
    docs: [],
    doc: null
  },
  getters: {
    galleryCount: state => state.docs.length,
    getGallery: state => state.docs,
    getGalleryItem: state => state.doc,
    getGalleryId: state => {
      if (state.doc) {
        return state.doc._id
      }
    },
    getAllGallery: state => number => {
      if (number === null) {
        return state.docs
      }
      state.docs.forEach(v => {
        console.log(`getAllGallery ${v._id}`)
      })
      return state.docs
    },
    getGalleryTitleByPostId: state => id => state.docs.find(doc => doc._id === id).title,
    // eslint-disable-next-line no-unused-vars
    getGalleryWithTitleDatas: (state, getters) => {
      const { doc } = state
      if (doc) {
        return {
          ...doc,
          titleDatas: [],
          slides: doc.urls
        }
      }
      return null
    }
  },
  actions: {
    /* 按照id获取一篇文章 */
    [LOAD_GALLERY_ITEM_ASYNC]({ commit }, payload) {
      return new Promise((resolve, reject) => {
        this._vm.$axios({
          commit,
          url: `${BASE_GALLERY_ID_URL}${payload.id}`,
          doHideAlert: true,
          success(result) {
            // 保存文章
            commit(LOAD_GALLERY_ITEM, result.doc)
            // 向前端通知操作成功
            resolve(result.doc)
          },
          fail(err) {
            // 向前端通知操作失败
            reject(err)
          }
        })
      })
    },
    /* 获取所有文章 */
    [LOAD_GALLERY_ASYNC]({ commit }) {
      return new Promise((resolve, reject) => {
        this._vm.$axios({
          commit,
          url: `${BASE_GALLERY_URL}`,
          doHideAlert: true,
          success(result) {
            // 保存文章
            commit(LOAD_GALLERY, result.docs)
            // 向前端通知操作成功
            resolve(result.docs)
          },
          fail(err) {
            // 向前端通知操作失败
            reject(err)
          }
        })
      })
    }
  },
  mutations: {
    /* 保存所有文章信息 */
    [LOAD_GALLERY](state, payload) {
      state.docs = payload
    },
    /* 保存当前文章信息 */
    [LOAD_GALLERY_ITEM](state, payload) {
      state.doc = payload
    },
    /* 清空当前文章信息 */
    [CLEAR_GALLERY](state) {
      state.doc = null
    }
  }
}
export default gallery



// WEBPACK FOOTER //
// ./src/components/Gallery/module.js